import React from 'react'
import './Pétrole.css'

function Pétrole() {
  return (
    <div className="pétrole-pétrole-wrapper">
      <div className="Gaz">
        <h2>Pétrole et gaz </h2>
        <p>Nous apportons notre savoir-faire en automatisation et maintenance industrielle aux installations pétrolières et gazières, garantissant fiabilité, sécurité et optimisation des opérations.

</p>
      </div>
    </div>
  )
}

export default Pétrole
